import { QuestionCircleOutlined } from '@ant-design/icons';
import { SelectLang as UmiSelectLang,history,useIntl } from '@umijs/max';
import React from 'react';
import {Button} from "antd";


export const SelectLang = () => {
  return (
    <UmiSelectLang
      style={{
        padding: 4,
      }}
      className="custom-select-lang"
    />
  );
};

export const Question = () => {
  return (
    <div
      style={{
        display: 'flex',
        height: 26,
      }}
      onClick={() => {
        window.open('https://pro.ant.design/docs/getting-started');
      }}
    >
      <QuestionCircleOutlined />
    </div>
  );
};
export const ActionButton = ({url,text,...rest})=>{
    const intl = useIntl();
    return(
        <>
            <Button
                onClick={()=>{
                    history.push(url)
                }}
                {...rest}
            >
                {text}
            </Button>
        </>

    )
}